import { render, staticRenderFns } from "./iconTicket.vue?vue&type=template&id=37d231c3&scoped=true"
import script from "./iconTicket.vue?vue&type=script&lang=js"
export * from "./iconTicket.vue?vue&type=script&lang=js"
import style0 from "./iconTicket.vue?vue&type=style&index=0&id=37d231c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d231c3",
  null
  
)

export default component.exports